import styles from './style.module.css';

// The line that moves between days or months: previous, the title, next. A
// phone's day line spans the full width with the arrows at the edges; the
// desktop's month line sits compact at the left. Both are rendered and the
// flags say which size each one is for. Next is disabled rather than hidden
// at today, so the line keeps its shape. The title is the page's h1, or an h2
// under a page heading of its own (level 2).
export function DateNav({ phone, desktop, title, level, previousLabel, nextLabel, onPrevious, onNext, canGoNext }) {
  const classNames = [ styles.nav ];

  if (phone === true) {
    classNames.push(styles.phone);
  }

  if (desktop === true) {
    classNames.push(styles.desktop);
  }

  let Title = 'h1';

  if (level === 2) {
    Title = 'h2';
  }

  return (
    <div className={ classNames.join(' ') }>
      <button className={ styles.arrow } type='button' aria-label={ previousLabel } onClick={ onPrevious }>
        <span className={ styles.previous }></span>
      </button>

      <Title className={ styles.title }>{ title }</Title>

      <button className={ styles.arrow } type='button' aria-label={ nextLabel } onClick={ onNext } disabled={ canGoNext === false }>
        <span className={ styles.next }></span>
      </button>
    </div>
  );
}
